import { useSelector } from 'react-redux';
import AdditionalSubscriptionRow from './AdditionalSubscriptionRow';
import { Account, OrganizationFeature } from '../../../../models';
import {
  fromCommerceSubscriptions,
} from '../../../../store';

export interface TrueTestSubscriptionDetailsProps {
  account: Account | null,
  organizationId: number,
}

const TrueTestSubscriptionDetails = (props: TrueTestSubscriptionDetailsProps) => {
  const {
    account,
    organizationId,
  } = props;

  const currentTrueTestSubscription = useSelector(
    fromCommerceSubscriptions.selectActiveByAccountIdAndFeature(
      Number(account?.id),
      OrganizationFeature.TRUE_TEST,
    ),
  )?.[0];

  const onRefreshSubscription = () => {
    if (account?.id) {
      fromCommerceSubscriptions.doGetActiveByAccountId(account.id);
    }
  };

  const getName = () => 'subscriptions.truetest.title';

  return (
    <>
      {
        currentTrueTestSubscription && (
          <AdditionalSubscriptionRow
            key={getName()}
            name={getName()}
            organizationId={organizationId}
            currentSubscription={currentTrueTestSubscription}
            initQuantity={currentTrueTestSubscription?.quota}
            metadataList={currentTrueTestSubscription?.metadata}
            feature={OrganizationFeature.TRUE_TEST}
            handleRefreshSubscription={onRefreshSubscription}
            account={account}
          />
        )
      }
    </>
  );
};

export default TrueTestSubscriptionDetails;
